<template>
  <div class="app">
    <router-view></router-view>
    <footer :class="$style.footer" class="wrap">
      <p>&copy; {{ getYear }} Rick Blything unless otherwise stated.</p>
      <p>Site by <a href="https://afew.london">AFEW</a></p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'app',

  computed: {
    getYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style>
@import url("../node_modules/sanitize.css/sanitize.css");

:root {
  margin: 0;
  padding: 0;
  font-family: "franklin-gothic-urw", sans-serif;
  font-size: 16px;
  font-weight: 300;

  @media (width >= 25em) {
    font-size: 18px;
  }

  @media (width >= 50em) {
    font-size: 21px;
  }

  @media (width >= 100em) {
    font-size: 24px;
  }
}

body,
html {
  min-width: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
ul,
ol,
dl,
hr,
br {
  margin-top: 0;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
}

h1,
h2,
h3,
h4 {
  line-height: 1.2;
}

p {
  line-height: 1.4;
}

b {
  font-weight: 600;
}

main {
  & h1,
  & h2,
  & p {
    & a {
      color: inherit;
      text-decoration: none;
      border-bottom: 0.07em solid #999;
      word-wrap: break-word;

      &:hover {
        color: #777;
        border-color: #777;
      }
    }
  }
}

.app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
}

.wrap {
  margin-right: auto;
  margin-left: auto;
}

.aligncenter {
  display: block;
  margin-right: auto;
  margin-left: auto;
}
</style>

<style module lang="postcss">
.footer {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  padding: 1rem 1rem;
  width: 100%;
  max-width: 62.5em;
  border-top: 1px solid #f8f9f9;

  @media (width >= 50em) {
    padding: 1rem 4rem;
  }

  & p {
    margin-bottom: 0;
    font-size: 0.675rem;
  }

  & a {
    color: #ff2058;
    text-decoration: none;
    border-bottom: 0.1rem solid #ccc;

    &:hover {
      border-bottom-color: #ff2058;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?75ae451a